"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const whatsNewSlice_1 = require("../../../../redux/slices/whatsNewSlice");
const core_1 = require("@material-ui/core");
const snackBar_1 = __importDefault(require("../modals/snackBar"));
const get_1 = __importDefault(require("lodash/get"));
const moment_1 = __importDefault(require("moment"));
const svgIcons_1 = require("../../../../svgIcons");
require("./whatsNewList.scss");
const whatsNewForm_1 = __importDefault(require("../modals/whatsNewForm"));
const whatsNewDelete_1 = __importDefault(require("../modals/whatsNewDelete"));
const whatsNewPopup_1 = __importDefault(require("../../../../shared/components/whatsNew/whatsNewPopup"));
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const adminPagination_1 = __importDefault(require("../../../../shared/components/adminPagination/adminPagination"));
const tableHead = [
    {
        key: "ID",
        value: "id"
    }, {
        key: "Title",
        value: "title"
    }, {
        key: "Published Date",
        value: "created_at"
    }, {
        key: "Count",
        value: "seen"
    }, {
        key: "Action",
        value: "action"
    }
];
class WhatsNewList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            currentPage: 1,
            count: 0,
            q: ''
        };
        this.resetState = () => {
            this.setState({
                currentPage: 1,
                q: ''
            });
            const element = document.querySelector('#search-whats-new');
            const event = new Event('change');
            element.addEventListener('change', function () {
                element.value = '';
            }, false);
            element.dispatchEvent(event);
        };
        this.getWhatsNewList = (event, page) => {
            this.props.getList({
                offset: (page - 1),
                limit: this.props.limit,
                q: this.state.q
            });
            this.setState({ currentPage: page });
        };
        // set pagination object data
        this.setPaginationData = () => {
            const { count, limit } = this.props;
            const { currentPage } = this.state;
            const from = currentPage === 1 ? currentPage : (((currentPage - 1) || 1) * limit) + 1;
            let to = currentPage === 1 ? limit : (from + limit) - 1;
            if (to > count) {
                to = count;
            }
            return { from, to, count: Math.ceil(count / limit), currentPage, total: count, pageChange: this.getWhatsNewList };
        };
        this.handleFormModalChange = () => {
            this.props.toggleAddModal();
        };
        this.handleDetailsModalChange = (id) => {
            this.props.getSingleWhatsNew(id);
            setTimeout(() => {
                this.props.toggleDetailsModal();
            }, 100);
        };
    }
    componentDidMount() {
        this.props.getList({ limit: this.props.limit });
    }
    getTableCell(row, val, key) {
        let cell = (react_1.default.createElement("span", null, get_1.default(row, val.value)));
        if (val.value === "title") {
            cell = (react_1.default.createElement("span", { className: "wn-title" }, get_1.default(row, val.value)));
        }
        else if (val.value === "createdAt" || val.value === "created_at") {
            cell = (react_1.default.createElement("span", null,
                moment_1.default(get_1.default(row, val.value)).format('MMM DD, YYYY').toUpperCase(),
                react_1.default.createElement("br", null),
                moment_1.default(get_1.default(row, val.value)).format('hh:mm').toUpperCase()));
        }
        else if (val.value === "action") {
            const id = get_1.default(row, 'id');
            const deleted = get_1.default(row, 'deleted');
            cell = !deleted ? (react_1.default.createElement("button", { className: "delete-btn", key: key, onClick: (e) => this.openDeleteWhatsNewModal(e, id) },
                react_1.default.createElement(svgIcons_1.DeleteRedIcon, null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("span", null, "Delete"))) : (react_1.default.createElement("span", null, "Deleted"));
        }
        return (react_1.default.createElement(core_1.TableCell, { key: key, className: "admin-cases-nowrap" }, cell));
    }
    searchWhatsNew(e) {
        const val = e.target.value;
        if (val.length >= 3 || !val) {
            this.setState({
                currentPage: 1,
                q: val,
            });
            this.props.getList({
                offset: 0,
                limit: this.props.limit,
                q: val
            });
        }
    }
    openDeleteWhatsNewModal(event, id) {
        event.stopPropagation();
        this.props.triggerModal({
            key: 'whatsNew.delete.data',
            val: { id }
        });
        this.props.triggerModal({ key: 'whatsNew.delete.open', val: true });
    }
    render() {
        const { whatsNew } = this.props;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "row my-10" },
                react_1.default.createElement("div", { className: "whats-new-filter my-10" },
                    react_1.default.createElement("div", { className: "left-side" }),
                    react_1.default.createElement("div", { className: "right-side" },
                        react_1.default.createElement(core_1.Button, { className: "v2-btn v2-btn-primary", disableFocusRipple: true, onClick: () => {
                                this.props.toggleAddModal();
                            } }, "Create New"))),
                react_1.default.createElement("div", { className: "search-pagination" },
                    react_1.default.createElement("div", { className: "search-box" },
                        react_1.default.createElement("input", { type: "text", placeholder: "Search", id: "search-whats-new", onChange: (e) => this.searchWhatsNew(e) })),
                    this.props.count > this.props.limit && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() })),
                react_1.default.createElement(core_1.TableContainer, { className: "clearfix whats-new-table-container" },
                    react_1.default.createElement(core_1.Table, { "aria-label": "table", className: "table admin-panel-table table-history admin-wn-table" },
                        react_1.default.createElement(core_1.TableHead, { className: "admin-panel-table-thead" },
                            react_1.default.createElement(core_1.TableRow, null, tableHead.map((val, key) => {
                                return (react_1.default.createElement(core_1.TableCell, { key: key }, val.key));
                            }))),
                        react_1.default.createElement(core_1.TableBody, { className: "admin-panel-table-tbody" }, whatsNew.length > 0 ? whatsNew.map((row, key) => {
                            return (react_1.default.createElement(core_1.TableRow, { key: key, onClick: () => {
                                    this.handleDetailsModalChange(row.id);
                                } }, tableHead.map((val, key) => this.getTableCell(row, val, key))));
                        }) : react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, null, "No results to show."))))),
                this.props.count > this.props.limit && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() })),
            react_1.default.createElement(snackBar_1.default, null),
            react_1.default.createElement(whatsNewForm_1.default, { toggleModal: this.handleFormModalChange, resetParentState: this.resetState }),
            react_1.default.createElement(whatsNewPopup_1.default, { adminView: true }),
            react_1.default.createElement(whatsNewDelete_1.default, null)));
    }
}
const mapStateToProps = (state) => {
    const { whatsNew } = state;
    return {
        whatsNew: whatsNew.list || [],
        count: whatsNew.count || 0,
        limit: whatsNew.limit || 0
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getList: (data) => dispatch(whatsNewSlice_1.getWhatsNewList(data)),
        getSingleWhatsNew: (data) => dispatch(whatsNewSlice_1.getSingleWhatsNew(data)),
        toggleAddModal: () => dispatch(whatsNewSlice_1.toggleAddModal()),
        toggleDetailsModal: () => dispatch(whatsNewSlice_1.toggleDetailsModal()),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WhatsNewList);
